/* Shared product-card interactions. Uses data attributes as the public API and
   reuses the existing product-quick-view markup/interaction contract. */

(function () {
  'use strict';

  var CART_DEBOUNCE_MS = 300;
  var REMOVE_CONFIRM_MS = 4000;

  var cartSnapshot = null;
  var cartRefreshPromise = null;
  var cartMutationQueue = Promise.resolve();
  var cartRefreshTimer = null;
  /** variantId -> целевое количество, ещё не подтверждённое сервером */
  var pendingQuantities = {};
  /** variantId -> id таймера дебаунса */
  var pendingTimers = {};
  /** карточка, на которой сейчас висит вопрос «Убрать?» — она всегда одна */
  var confirmCard = null;
  var confirmTimer = null;

  function getSelectedVariantId(card) {
    var input = card.querySelector('[data-product-card-variant-input]');
    return input ? String(input.value) : '';
  }

  function hasVisibleProperties(item) {
    var properties = item && item.properties ? item.properties : {};
    return Object.keys(properties).some(function (key) {
      return properties[key] !== null && properties[key] !== '';
    });
  }

  function findPlainCartLine(variantId) {
    if (!cartSnapshot || !variantId) return null;
    return cartSnapshot.items.find(function (item) {
      return String(item.id) === String(variantId)
        && !hasVisibleProperties(item)
        && !item.selling_plan_allocation;
    }) || null;
  }

  function setQuantityError(card, message) {
    var error = card.querySelector('[data-product-card-quantity-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function selectedVariantAvailable(card) {
    var selected = card.querySelector('[data-product-card-variant][aria-pressed="true"]');
    if (selected) return selected.dataset.variantAvailable === 'true';
    var submit = card.querySelector('[data-product-card-add]');
    return Boolean(submit && !submit.disabled);
  }

  /* Пока запрос в полёте (или ждёт дебаунса), источник истины для UI — цель,
     а не снапшот: иначе оптимистичное число откатывалось бы на каждый
     syncAllCards. */
  function displayedQuantity(variantId) {
    if (Object.prototype.hasOwnProperty.call(pendingQuantities, variantId)) {
      return pendingQuantities[variantId];
    }
    var line = findPlainCartLine(variantId);
    return line ? Number(line.quantity) : 0;
  }

  function syncCardCartState(card) {
    if (!cartSnapshot) return;

    var variantId = getSelectedVariantId(card);
    var line = findPlainCartLine(variantId);
    var quantity = displayedQuantity(variantId);
    var productForm = card.querySelector('.product-card-premium__product-form');
    var stepper = card.querySelector('[data-product-card-quantity]');
    var value = card.querySelector('[data-product-card-quantity-value]');
    var increase = card.querySelector('[data-product-card-quantity-increase]');
    var cartBadge = card.querySelector('[data-product-card-cart-badge]');

    if (!productForm || !stepper || !value) return;

    productForm.hidden = quantity > 0;
    stepper.hidden = quantity <= 0;
    stepper.dataset.lineKey = line ? line.key : '';
    stepper.dataset.variantId = variantId;
    value.textContent = String(quantity);

    if (cartBadge) {
      cartBadge.textContent = String(quantity);
      cartBadge.hidden = quantity <= 0;
    }

    if (increase) increase.disabled = !selectedVariantAvailable(card);

    announceQuantity(card, quantity);
  }

  /* Живой регион отдельно от <output>: озвучивать надо товар и количество,
     а не голое число — в гриде их два десятка. Стартовое значение приходит
     из Liquid, чтобы первая синхронизация ничего не наговорила. */
  function announceQuantity(card, quantity) {
    var announce = card.querySelector('[data-product-card-quantity-announce]');
    if (!announce) return;

    if (announce.dataset.lastQuantity === String(quantity)) return;
    announce.dataset.lastQuantity = String(quantity);

    var template = announce.dataset.announceTemplate;
    announce.textContent = template ? template.replace('__COUNT__', String(quantity)) : '';
  }

  function syncAllCards(root) {
    (root || document).querySelectorAll('[data-product-card-premium]').forEach(syncCardCartState);
  }

  function cartJsonUrl() {
    return (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
  }

  /* Список секций берём у cart-notification, чтобы не держать второй хардкод:
     тот же контракт использует product-form.js. */
  function cartNotificationElement() {
    var element = document.querySelector('cart-notification');
    return element && typeof element.getSectionsToRender === 'function' ? element : null;
  }

  function cartSectionsToRender() {
    var notification = cartNotificationElement();
    if (!notification) return ['cart-icon-bubble'];

    return notification.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function renderCartIconBubble(cart) {
    var html = cart && cart.sections && cart.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var inner = parsed.querySelector('.shopify-section') || parsed.body;
    // Пустая корзина возвращает секцию без .cart-count-bubble — замена innerHTML
    // сама убирает счётчик, отдельная логика скрытия не нужна.
    bubble.innerHTML = inner.innerHTML;
  }

  function refreshCart(force) {
    if (cartRefreshPromise) {
      if (!force) return cartRefreshPromise;
      return cartRefreshPromise.then(function () {
        return refreshCart();
      });
    }

    cartRefreshPromise = fetch(cartJsonUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart load failed');
        return response.json();
      })
      .then(function (cart) {
        cartSnapshot = cart;
        syncAllCards(document);
        return cart;
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        cartRefreshPromise = null;
        return cart;
      });

    return cartRefreshPromise;
  }

  function scheduleCartRefresh() {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(function () {
      refreshCart(true);
    }, 40);
  }

  /* Отправляем абсолютное целевое количество, а не дельту: запрос идемпотентен,
     и серия быстрых кликов схлопывается в один вызов /cart/change.js. */
  function flushQuantity(card, variantId) {
    var sentQuantity = null;

    delete pendingTimers[variantId];

    cartMutationQueue = cartMutationQueue
      .catch(function () {})
      .then(function () {
        if (!Object.prototype.hasOwnProperty.call(pendingQuantities, variantId)) return null;

        var line = findPlainCartLine(variantId);
        if (!line) throw new Error(window.cartStrings && window.cartStrings.error || 'Cart update failed');

        sentQuantity = pendingQuantities[variantId];
        var body = {
          id: line.key,
          quantity: sentQuantity,
          sections: cartSectionsToRender().join(','),
          sections_url: window.location.pathname
        };

        return fetch(window.routes && window.routes.cart_change_url || '/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        })
          .then(function (response) {
            return response.json().then(function (cart) {
              if (!response.ok || cart.status) {
                throw new Error(cart.description || cart.message || 'Cart update failed');
              }
              return cart;
            });
          });
      })
      .then(function (cart) {
        if (!cart) return;

        // Цель снимаем, только если за время полёта её не подвинули новым
        // кликом: иначе следующий flush отправит уже устаревшее число.
        if (pendingQuantities[variantId] === sentQuantity) delete pendingQuantities[variantId];

        cartSnapshot = cart;
        renderCartIconBubble(cart);

        // Снапшот popup'а тоже надо подвинуть, иначе следующее «В корзину»
        // посчитает дельту от устаревшего состояния и покажет этот товар как
        // только что добавленный. Открывать popup на «+» намеренно не хотим.
        var notification = cartNotificationElement();
        if (notification && typeof notification.syncSnapshot === 'function') {
          notification.syncSnapshot(cart);
        }

        syncAllCards(document);
        document.dispatchEvent(
          new CustomEvent('cart:sections-rendered', { detail: { cart: cart } })
        );
      })
      .catch(function (error) {
        // Оптимистичное число не подтвердилось — откатываем на серверную правду.
        delete pendingQuantities[variantId];
        setQuantityError(card, error.message || window.cartStrings && window.cartStrings.error);
        return refreshCart(true);
      });
  }

  function applyRemoveConfirm(card, on) {
    var stepper = card.querySelector('[data-product-card-quantity]');
    var decrease = card.querySelector('[data-product-card-quantity-decrease]');
    if (!stepper) return;

    if (on) stepper.dataset.confirmRemove = 'true';
    else delete stepper.dataset.confirmRemove;

    if (!decrease) return;
    var label = on ? decrease.dataset.removeLabel : decrease.dataset.decreaseLabel;
    if (label) decrease.setAttribute('aria-label', label);
  }

  function clearRemoveConfirm() {
    if (!confirmCard) return;
    var card = confirmCard;
    confirmCard = null;
    window.clearTimeout(confirmTimer);
    applyRemoveConfirm(card, false);
  }

  function startRemoveConfirm(card) {
    clearRemoveConfirm();
    confirmCard = card;
    applyRemoveConfirm(card, true);
    confirmTimer = window.setTimeout(clearRemoveConfirm, REMOVE_CONFIRM_MS);
  }

  function isConfirmingRemove(card) {
    var stepper = card.querySelector('[data-product-card-quantity]');
    return Boolean(stepper && stepper.dataset.confirmRemove === 'true');
  }

  function changeCardQuantity(card, delta) {
    var variantId = getSelectedVariantId(card);
    if (!variantId || !cartSnapshot) return;

    setQuantityError(card, '');

    pendingQuantities[variantId] = Math.max(0, displayedQuantity(variantId) + delta);
    syncAllCards(document);

    window.clearTimeout(pendingTimers[variantId]);
    pendingTimers[variantId] = window.setTimeout(function () {
      flushQuantity(card, variantId);
    }, CART_DEBOUNCE_MS);
  }

  function syncQuickView(card, trigger) {
    var quickViewId = card.dataset.productCardQuickViewId;
    if (!quickViewId) return;

    var dialog = document.getElementById('QuickView-' + quickViewId);
    if (!dialog) return;

    var input = dialog.querySelector('[data-quick-view-variant-input]');
    var price = dialog.querySelector('[data-quick-view-price]');
    var unit = dialog.querySelector('[data-quick-view-unit]');
    var compare = dialog.querySelector('[data-quick-view-compare]');
    var add = dialog.querySelector('[type="submit"]');
    var available = trigger.dataset.variantAvailable === 'true';
    var compareText = trigger.dataset.variantCompare || '';
    var unitText = trigger.dataset.variantTitle || '';

    if (input) input.value = trigger.dataset.variantId;
    if (price) price.textContent = trigger.dataset.variantPrice;
    if (unit) {
      unit.textContent = unitText;
      unit.hidden = !unitText;
    }
    if (compare) {
      compare.textContent = compareText;
      compare.hidden = !compareText;
    }
    if (add) add.disabled = !available;
  }

  function setCardVariant(card, trigger) {
    var input = card.querySelector('[data-product-card-variant-input]');
    var price = card.querySelector('[data-product-card-price]');
    var compare = card.querySelector('[data-product-card-compare]');
    var priceRow = card.querySelector('[data-product-card-price-row]');
    var saleBadge = card.querySelector('[data-product-card-sale-badge]');
    var customBadge = card.querySelector('[data-product-card-custom-badge]');
    var submit = card.querySelector('[data-product-card-add]');
    var submitLabel = card.querySelector('[data-product-card-add-label]');
    var available = trigger.dataset.variantAvailable === 'true';
    var compareText = trigger.dataset.variantCompare || '';
    var discountText = trigger.dataset.variantDiscount || '';

    card.querySelectorAll('[data-product-card-variant]').forEach(function (button) {
      button.setAttribute('aria-pressed', button === trigger ? 'true' : 'false');
    });

    if (input) input.value = trigger.dataset.variantId;
    if (price) price.textContent = trigger.dataset.variantPrice;
    if (compare) {
      compare.textContent = compareText;
      compare.hidden = !compareText;
    }
    if (priceRow) {
      priceRow.classList.toggle('product-card-premium__price-row--sale', Boolean(compareText));
    }
    if (saleBadge) {
      saleBadge.textContent = discountText;
      saleBadge.hidden = !discountText;
    }
    if (customBadge) customBadge.hidden = Boolean(discountText);

    if (submit) {
      var label = available ? submit.dataset.addLabel : submit.dataset.soldOutLabel;
      var productTitle = submit.dataset.productTitle;
      submit.disabled = !available;
      submit.removeAttribute('aria-disabled');
      submit.setAttribute('aria-label', productTitle ? label + ' — ' + productTitle : label);
      if (submitLabel) submitLabel.textContent = label;
    }

    syncQuickView(card, trigger);
    setQuantityError(card, '');
    clearRemoveConfirm();
    syncCardCartState(card);
  }

  function initCard(card) {
    if (card.dataset.productCardInitialized === 'true') return;
    card.dataset.productCardInitialized = 'true';

    card.querySelectorAll('[data-product-card-variant]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setCardVariant(card, trigger);
      });
    });

    var decrease = card.querySelector('[data-product-card-quantity-decrease]');
    var increase = card.querySelector('[data-product-card-quantity-increase]');
    if (decrease) {
      decrease.addEventListener('click', function () {
        // Последняя единица уходит только со второго клика: молчаливое
        // удаление по промаху не отличить от «уменьшил количество».
        if (displayedQuantity(getSelectedVariantId(card)) <= 1 && !isConfirmingRemove(card)) {
          startRemoveConfirm(card);
          return;
        }
        clearRemoveConfirm();
        changeCardQuantity(card, -1);
      });
    }
    if (increase) {
      increase.addEventListener('click', function () {
        clearRemoveConfirm();
        changeCardQuantity(card, 1);
      });
    }

    syncCardCartState(card);
  }

  /* Диалог живёт в <template> рядом с карточкой и переезжает в body по первому
     клику. Если разметка старая (диалог уже в DOM) — работаем с ней как раньше. */
  function materializeQuickView(id) {
    var dialog = document.getElementById('QuickView-' + id);
    if (dialog) return dialog;

    var template = document.querySelector('[data-quick-view-template="' + id + '"]');
    if (!template || !template.content) return null;

    // По data-атрибуту, а не по id: section_id попадает в id как есть, и
    // экранировать его под селектор незачем.
    var fragment = template.content.cloneNode(true);
    dialog = fragment.querySelector('[data-product-quick-view]');
    if (!dialog) return null;

    document.body.appendChild(fragment);
    return dialog;
  }

  function mountQuickView(trigger) {
    var dialog = materializeQuickView(trigger.dataset.quickViewTrigger);
    if (!dialog) return null;

    if (dialog.parentElement !== document.body) document.body.appendChild(dialog);

    /* Вложенные триггеры (попап подборки несёт рельсу карточек состава со
       своими quick view) появляются в DOM только при материализации — биндим
       их здесь; guard-флаг в initQuickView исключает двойной бинд. */
    initQuickView(dialog);

    /* Диалог отрендерен сервером на варианте по умолчанию, а пользователь мог
       переключить вариант до первого открытия: syncQuickView в тот момент молча
       выходил — диалога ещё не было. Досеиваем выбранный вариант здесь. */
    var card = trigger.closest('[data-product-card-premium]');
    if (card) {
      var selected = card.querySelector('[data-product-card-variant][aria-pressed="true"]');
      if (selected) syncQuickView(card, selected);
    }

    var panel = dialog.querySelector('.product-quick-view__panel');
    var backdrop = dialog.querySelector('.product-quick-view__backdrop');
    var drag = null;
    var closing = false;

    function isSheet() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function hideDialog() {
      dialog.hidden = true;
      closing = false;
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(trigger);
      if (drag) drag.reset();
      if (backdrop) backdrop.style.opacity = '';
    }

    function close() {
      if (dialog.hidden || closing) return;
      if (!panel || !window.DSSheet) {
        hideDialog();
        return;
      }
      closing = true;
      window.DSSheet.flyOut(panel, hideDialog, {
        up: !isSheet(),
        backdrop: isSheet() ? backdrop : null,
      });
    }

    function open() {
      if (drag) drag.reset();
      if (backdrop) backdrop.style.opacity = '';
      closing = false;
      dialog.hidden = false;
      /* Картинка диалога lazy и до открытия не грузилась: показываем spinner,
         пока кадр не приедет, вместо белой дыры на месте фото. */
      if (window.DSPopupMedia) window.DSPopupMedia.track(dialog);
      document.body.classList.add('overflow-hidden');
      // Целиться нужно в панель: у самого диалога нет tabindex, поэтому
      // trapFocus(dialog) фокус не переносил и он оставался на триггере.
      if (typeof trapFocus === 'function') trapFocus(dialog, panel || dialog);
    }

    // Escape — на document: на самом диалоге он молчал, стоило фокусу уйти наружу
    if (window.DSSheet) {
      window.DSSheet.onEscape(function () {
        return !dialog.hidden;
      }, close);

      if (panel) {
        drag = window.DSSheet.dragToDismiss(panel, {
          isEnabled: function () {
            return isSheet() && !dialog.hidden && !closing;
          },
          onDismiss: close,
          onDrag: function (delta) {
            if (!backdrop) return;
            var progress = Math.min(1, Math.max(0, delta) / Math.max(panel.offsetHeight, 1));
            backdrop.style.opacity = String(1 - progress * 0.7);
          },
        });
      }
    }

    dialog.querySelectorAll('[data-quick-view-close]').forEach(function (element) {
      element.addEventListener('click', close);
    });

    var form = dialog.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function () {
        setTimeout(close, 400);
      });
    }

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(trigger)) {
        close();
        dialog.remove();
      }
    });

    return { open: open };
  }

  function initQuickView(root) {
    root.querySelectorAll('[data-quick-view-trigger]').forEach(function (trigger) {
      if (trigger.dataset.productSystemInitQv) return;
      trigger.dataset.productSystemInitQv = 'true';

      var controls = null;

      trigger.addEventListener('click', function () {
        if (!controls) controls = mountQuickView(trigger);
        if (controls) controls.open();
      });
    });
  }

  /* «С этим покупают» приезжает после первого рендера: <product-recommendations>
     подменяет свой innerHTML ответом Shopify, и карточки внутри остаются без
     обработчиков — ни лупы, ни степпера, ни переключения фасовки. Секцию
     заново инициализируем по факту подмены. */
  function initRecommendations(root) {
    root.querySelectorAll('product-recommendations').forEach(function (host) {
      if (host.dataset.productCardPremiumRecommendations) return;
      host.dataset.productCardPremiumRecommendations = 'true';

      var observer = new MutationObserver(function () {
        init(host);
      });
      observer.observe(host, { childList: true });

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(host)) observer.disconnect();
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-card-premium]').forEach(initCard);
    initQuickView(root);
    initRecommendations(root);
  }

  window.ProductCardPremium = window.ProductCardPremium || {};
  window.ProductCardPremium.init = init;
  window.ProductCardPremium.refreshCart = refreshCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Вопрос «Убрать?» снимается кликом мимо и Escape. Слушатель в фазе всплытия:
  // клик по самой кнопке успевает обработаться до проверки.
  document.addEventListener('click', function (event) {
    if (!confirmCard || confirmCard.contains(event.target)) return;
    clearRemoveConfirm();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') clearRemoveConfirm();
  });

  document.addEventListener('product:added', function () {
    refreshCart(true);
  });

  document.addEventListener('cart:sections-rendered', function (event) {
    if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) {
      cartSnapshot = event.detail.cart;
      syncAllCards(document);
      return;
    }
    scheduleCartRefresh();
  });

  refreshCart();
})();
